// @ts-nocheck
import * as Types from "../../../../types/types-v2.generated";

import { gql } from "@apollo/client";
import { LogLineFieldsFragmentDoc } from "./LogLineContent.v2.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type LogLineDetailV2QueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  id: Types.Scalars["ID"]["input"];
  logTextMaxLength?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type LogLineDetailV2Query = {
  __typename?: "RootQuery";
  server: {
    __typename?: "Server";
    id: string;
    logLine?: {
      __typename?: "LogLine";
      childText?: string | null;
      details?: Record<string, unknown> | null;
      queryId?: string | null;
      id: string;
      occurredAt: string;
      logClassification?: string | null;
      logText?: string | null;
      backendPid?: number | null;
      databaseId?: string | null;
      postgresRoleId?: string | null;
      postgresRoleName?: string | null;
    } | null;
  };
};

export const LogLineDetailV2Document = gql`
  query LogLineDetailV2($serverId: ID!, $id: ID!, $logTextMaxLength: Int) {
    server(id: $serverId) {
      id
      logLine(id: $id) {
        ...LogLineFields
        childText
        details
        queryId
      }
    }
  }
  ${LogLineFieldsFragmentDoc}
`;

/**
 * __useLogLineDetailV2Query__
 *
 * To run a query within a React component, call `useLogLineDetailV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLogLineDetailV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogLineDetailV2Query({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      id: // value for 'id'
 *      logTextMaxLength: // value for 'logTextMaxLength'
 *   },
 * });
 */
export function useLogLineDetailV2Query(
  baseOptions: Apollo.QueryHookOptions<
    LogLineDetailV2Query,
    LogLineDetailV2QueryVariables
  > &
    (
      | { variables: LogLineDetailV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogLineDetailV2Query, LogLineDetailV2QueryVariables>(
    LogLineDetailV2Document,
    options,
  );
}
export function useLogLineDetailV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LogLineDetailV2Query,
    LogLineDetailV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LogLineDetailV2Query,
    LogLineDetailV2QueryVariables
  >(LogLineDetailV2Document, options);
}
// @ts-ignore
export function useLogLineDetailV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LogLineDetailV2Query,
    LogLineDetailV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LogLineDetailV2Query,
  LogLineDetailV2QueryVariables
>;
export function useLogLineDetailV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LogLineDetailV2Query,
        LogLineDetailV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LogLineDetailV2Query | undefined,
  LogLineDetailV2QueryVariables
>;
export function useLogLineDetailV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LogLineDetailV2Query,
        LogLineDetailV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LogLineDetailV2Query,
    LogLineDetailV2QueryVariables
  >(LogLineDetailV2Document, options);
}
export type LogLineDetailV2QueryHookResult = ReturnType<
  typeof useLogLineDetailV2Query
>;
export type LogLineDetailV2LazyQueryHookResult = ReturnType<
  typeof useLogLineDetailV2LazyQuery
>;
export type LogLineDetailV2SuspenseQueryHookResult = ReturnType<
  typeof useLogLineDetailV2SuspenseQuery
>;
export type LogLineDetailV2QueryResult = Apollo.QueryResult<
  LogLineDetailV2Query,
  LogLineDetailV2QueryVariables
>;
